import { render, staticRenderFns } from "./MarketingHdykTable.vue?vue&type=template&id=fabc1c50"
import script from "./MarketingHdykTable.vue?vue&type=script&lang=js"
export * from "./MarketingHdykTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports